export const LOCALE = {
    RU: 'ru',
    EN: 'en',
};

export const PAYMENT_STATUS = {
    NTST: 'NTST',
    RCVD: 'RCVD',
    ACTC: 'ACTC',
    ACWP: 'ACWP',
    RJCT: 'RJCT',
};

export const WIDGET_TYPE = {
    CHARITY: 'CHARITY',
    PAYMENT: 'PAYMENT',
};

export const MAX_SBP_TRANSFER_AMOUNT = 1000000;
